export default __webpack_public_path__ + "static/media/portfolio-hover-158.82de0b23.jpg";